(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(e) {
      e.preventDefault();
      const { closeAnnouncement } = e.target.dataset;
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove();
      } else {
        this.remove();
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
        this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this));
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }

    connectedCallback() {
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.offsetHeight + 'px');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('quality-products')) {
  class QualityProducts extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.strip = this.querySelector('[data-products-container]');
      this.more = this.querySelector('[data-quality-more]');
      this.previousButton = this.querySelector('[data-quality-prev]');
      this.nextButton = this.querySelector('[data-quality-next]');
      this.ids = new Set([...this.strip.querySelectorAll('[data-quality-product-id]')].map(el => el.dataset.qualityProductId));
      this.seenPages = new Set();
      this.nextURL = this.ids.size < Number(this.dataset.total) ? this.dataset.collectionUrl : null;
      this.label = this.more?.textContent;
      this.strip.addEventListener('scroll', () => this.check(), { passive: true, signal });
      this.more?.addEventListener('click', () => { this.failed = false; this.load(); }, { signal });
      this.previousButton.addEventListener('click', () => this.move(-1), { signal });
      this.nextButton.addEventListener('click', () => this.move(1), { signal });
      this.closest('tabs-component')?.addEventListener('tabChange', () => requestAnimationFrame(() => this.check()), { signal });
      this.observer = new IntersectionObserver(() => this.check(), { rootMargin: '100px 0px' });
      this.observer.observe(this);
      this.resizeObserver = new ResizeObserver(() => this.check());
      this.resizeObserver.observe(this.strip);
      this.updateButtons();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.controller = null;
    }
    updateButtons() {
      const end = this.strip.scrollWidth - this.strip.clientWidth - this.strip.scrollLeft <= 3;
      this.previousButton.disabled = this.strip.scrollLeft <= 3;
      this.nextButton.disabled = end && !this.nextURL;
    }
    check() {
      this.updateButtons();
      const box = this.getBoundingClientRect();
      if (!this.strip.clientWidth || box.bottom < 0 || box.top > innerHeight + 100 || this.closest('[hidden]')) return;
      if (!this.failed && this.strip.scrollWidth - this.strip.clientWidth - this.strip.scrollLeft < this.strip.clientWidth * 1.5) this.load();
    }
    move(direction) {
      this.failed = false;
      const card = this.strip.querySelector('[data-quality-product-id]');
      const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.strip).columnGap) : this.strip.clientWidth;
      this.strip.scrollBy({ left: direction * step * (innerWidth < 768 ? 2 : 4), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      this.check();
    }
    async load() {
      if (this.loading || !this.nextURL || !this.more) return;
      this.loading = true;
      this.more.disabled = true;
      this.more.textContent = this.dataset.loadingLabel;
      this.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(this.nextURL, location.origin);
        const collection = new URL(this.dataset.collectionUrl, location.origin);
        if (url.origin !== location.origin || url.pathname !== collection.pathname) throw new Error('Invalid collection page');
        url.searchParams.set('section_id', 'tirill-quality-page');
        if (this.seenPages.has(url.href)) throw new Error('Repeated collection page');
        const response = await fetch(url, { signal: this.controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const page = doc.querySelector('[data-quality-page]');
        if (!page || page.dataset.collectionHandle !== collection.pathname.split('/').filter(Boolean).pop()) throw new Error('Wrong collection');
        const cards = [...page.querySelectorAll('[data-quality-product-id]')];
        if (!cards.length) throw new Error('Missing products');
        const next = page.dataset.next || null;
        if (next && new URL(next, location.origin).searchParams.get('page') === url.searchParams.get('page')) throw new Error('Repeated pagination');
        const fresh = cards.filter(card => !this.ids.has(card.dataset.qualityProductId));
        if (!fresh.length && next) throw new Error('No new products');
        const fragment = document.createDocumentFragment();
        fresh.forEach(card => { this.ids.add(card.dataset.qualityProductId); fragment.append(card); });
        this.strip.insertBefore(fragment, this.more);
        this.seenPages.add(url.href);
        this.nextURL = next;
        this.more.hidden = !next;
        this.failed = false;
        this.dataset.loaded = String(this.ids.size);
        this.querySelector('grid-list')?.reShowVisibleGridItems?.();
      } catch (error) {
        if (error.name !== 'AbortError') this.failed = true;
      } finally {
        this.loading = false;
        this.more.disabled = false;
        this.more.textContent = this.label;
        this.removeAttribute('aria-busy');
        this.updateButtons();
      }
    }
  }
  customElements.define('quality-products', QualityProducts);
}

  } catch(e) { console.error(e); }
})();
})();
